'use strict'

module.exports = { version: '8.17.2' }
